const FiltersIconArrowDown = props => (
	<svg
		width="15"
		height="16"
		viewBox="0 0 15 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g id="keyboard_arrow_down">
			<path
				id="Vector"
				d="M4.63125 5.68433L7.5 8.54683L10.3688 5.68433L11.25 6.56558L7.5 10.3156L3.75 6.56558L4.63125 5.68433Z"
				fill="currentColor"
			/>
		</g>
	</svg>
);

export default FiltersIconArrowDown;
